import React from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import EnvironmentManager from 'Utils/environmentManager';

const TicketNumber = props => {
  const { data, showStatusText, showDate, onlyNumbers } = props;
      
  return (
    <>
      { !onlyNumbers && data && Object.keys(data).map((key, i) => (
        <React.Fragment key={ i }>
          { showDate && <div className="ticket-detail__card--date">{ key }</div> }
          <div
            className={ classnames({
              'ticket-detail__card--status-text': true,
              'ticket-detail__card--status-text--won': data[key]?.isHaveWon,
            }) }
          >
            { showStatusText && <React.Fragment>
              { data[key]?.isHaveWon ? (
                <div>
                  { EnvironmentManager.getMessageText({ key: 'description_raffle_tickets_winning' }) || 'Biletinize ikramiye isabet etmiştir.' }
                </div>
              ) :    EnvironmentManager.getMessageText({ key: 'description_raffle_tickets_losing' }) || 'Biletinize ikramiye isabet etmemiştir.'  }
            </React.Fragment> }
           
          </div>
          { !data[key]?.isHaveWon && <div className="ticket-detail__numbers">
            { data[key]?.barcodeStatusList.sort((a, b) => b.status.localeCompare(a.status)).map((bs, idx) => (
              <div
                className={ classnames({
                  'ticket-detail__numbers--item': true,
                  'ticket-detail__numbers--item--won': bs.status === 'WON',
                  'ticket-detail__numbers--item--lost': bs.status === 'LOST',
                }) }
                key={ idx }
              >
                { bs.barcode }
              </div>
            )) }
          </div> }
          { data[key]?.isHaveWon && <div>
            { data[key]?.barcodeStatusList.filter(item=>item.status === 'WON').sort((a, b) => b.status.localeCompare(a.status)).map((bs, idx) => (
              <div key={ idx } className='ticket-detail__won--numbers'>
                { bs.status === 'WON' &&  <div className='ticket-detail__text'>
                  <span>{ bs?.prizeName }</span>
                </div> }
                {  bs.status === 'WON' && <div className='ticket-detail__numbers'>
                  <div
                    className='ticket-detail__numbers--item ticket-detail__numbers--item--won'
                    key={ idx }
                  >
                    { bs.barcode }
                  </div>
                </div> }

              </div>
            )) }
            { data[key]?.barcodeStatusList.filter(item=>item.status === 'LOST').length > 0 && <div className='ticket-detail__card--status-text'>
              { EnvironmentManager.getMessageText({ key: 'description_raffle_tickets_losing' }) || 'Biletinize ikramiye isabet etmemiştir.' }
            </div> }
            { <div className="ticket-detail__numbers">
              { data[key]?.barcodeStatusList.filter(item=>item.status === 'LOST').sort((a, b) => b.status.localeCompare(a.status)).map((bs, idx) => (
                <div
                  className={ classnames({
                    'ticket-detail__numbers--item': true,
                    'ticket-detail__numbers--item--won': bs.status === 'WON',
                    'ticket-detail__numbers--item--lost': bs.status === 'LOST',
                  }) }
                  key={ idx }
                >
                  { bs.barcode }
                </div>
              )) }
            </div> }
          </div> }
        </React.Fragment>
      )) }
      
      { onlyNumbers && onlyNumbers.length > 1 && <div>
        { onlyNumbers.map((item, id) => (
          <div className='ticket-detail__result' key={ id }>
            <div className="ticket-detail__raffle-name">
              <span>{ item?.prizeName }</span>
            </div>
            <div className="ticket-detail__multiple-numbers">
              { item?.ticketNos.map((on, idx) => (
                <div
                  className="ticket-detail__multiple-numbers--item"
                  key={ idx }
                >
                  { on }
                </div>
              )) }
            </div>
          </div>
        )) }
      </div> }
            
      { onlyNumbers && onlyNumbers.length === 1 && <div className="ticket-detail__numbers">
        { onlyNumbers[0]?.ticketNos.map((on, idx) => (
          <div
            className={ classnames({
              'ticket-detail__numbers--item': true,
            }) }
            key={ idx }
          >
            { on }
          </div>

        )) }
      </div> }
  </>
  );
};

TicketNumber.propTypes = {
  data: PropTypes.object,
  showStatusText: PropTypes.bool,
  showDate: PropTypes.bool,
  onlyNumbers: PropTypes.object
};

export default TicketNumber;
